import dayjs from "dayjs";

export function calculateAge(dob) {
  if (!dob) return "";

  const birthDate = dayjs(dob);

  // Known min/default dates
  if (!birthDate.isValid() || birthDate.year() <= 1900) {
    return "";
  }

  const today = dayjs();
  const age = today.diff(birthDate, "year");

  return isNaN(age) || age < 0 ? "" : age;
}
